var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadAttachements(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 9.33301L2.1559 9.77471C2.76267 11.4939 3.06605 12.3535 3.75828 12.8432C4.45051 13.333 5.36206 13.333 7.18518 13.333L8.81482 13.333C10.6379 13.333 11.5495 13.333 12.2417 12.8432C12.934 12.3535 13.2373 11.4939 13.8441 9.77471L14 9.33301",
    stroke: "#242428",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 2.66634L8.00016 9.33301M8.00016 2.66634C7.53334 2.66634 6.66118 3.99587 6.3335 4.33301M8.00016 2.66634C8.46698 2.66634 9.33914 3.99587 9.66683 4.33301",
    stroke: "#242429",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadAttachements);
export default __webpack_public_path__ + "static/media/icon-upload-attachements.fa4ac9b8c61c6669b8177438c4141e7f.svg";
export { ForwardRef as ReactComponent };